import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentContent,
  selectCurrentEntity,
} from "../redux/selectors/playerSelector";
import { setReleasePodcastInfo } from "../redux/Slice/releasePodcastSlice";
import { openModal } from "../redux/Slice/modalSlice";
import { setInfoTrack } from "../redux/Slice/trackInfoSlice";
import { modalState } from "../utils/constants";

export const useOpenDrawerTrack = () => {
  const dispatch = useDispatch();
  const currentContent = useSelector(selectCurrentContent);
  const currentEntity = useSelector(selectCurrentEntity);

  const isRelease = currentEntity === "release";

  const isClosing = useSelector((state) => state.modalSlice.isClosing);

  const openDrawer = () => {
    if (isClosing) return;

    if (isRelease) {
      dispatch(setReleasePodcastInfo(currentContent));
      dispatch(openModal(modalState.RELEASE_PODCAST_INFO));
    } else {
      dispatch(setInfoTrack(currentContent));
      dispatch(openModal(modalState.TRACK_INFO));
    }
  };

  return openDrawer;
};
